module.exports = __webpack_public_path__ + "static/media/5af9aeef21bd9338588794.83163a02.jpg";